(function () {
  if (window.__CaInstantOptimized) return;
  window.__CaInstantOptimized = true;

  const isSupported = 'IntersectionObserver' in window;
  const config = {
    prefetchLimit: 5,
    prefetchReset: 15000,
    observerMargin: '200px',
    observerThreshold: 0.05,
    excludedPages: ['/checkout', '/cart', '/account', '/search', '/pages/contact', '/a/sc/amp'],
  };
  let prefetchCount = 0;

  const throttle = (fn, wait) => {
    let lastTime = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastTime >= wait) {
        lastTime = now;
        fn(...args);
      }
    };
  };

  const preloadLink = (url, as = 'image') => {
    if (!url || document.querySelector(`link[rel="preload"][href="${url}"]`)) return;
    const l = document.createElement('link');
    l.rel = 'preload';
    l.as = as;
    l.href = url;
    l.crossOrigin = 'anonymous';
    document.head.appendChild(l);
  };

  const prefetchLink = (url) => {
    if (prefetchCount >= config.prefetchLimit || document.querySelector(`link[rel="prefetch"][href="${url}"]`) || url.includes('#')) return;
    if (!url.startsWith(window.location.origin) || config.excludedPages.some(p => url.includes(p))) return;
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
    prefetchCount++;
    setTimeout(() => {
      l.remove();
      prefetchCount = Math.max(0, prefetchCount - 1);
    }, config.prefetchReset);
  };

  const forceEagerIfInViewport = () => {
    document.querySelectorAll('img[loading],video[preload]').forEach(el => {
      const rect = el.getBoundingClientRect();
      const inViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (inViewport) {
        if (el.tagName === 'IMG') {
          el.setAttribute('loading', 'eager');
          el.setAttribute('fetchpriority', 'high');
        }
        if (el.tagName === 'VIDEO') {
          el.setAttribute('preload', 'auto');
        }
      }
    });
  };

  const preloadVisibleElements = () => {
    const selectors = ['img', 'video', 'h1', 'h2', 'h3', '.ca-slide-title', '.ca-slide-subtitle', '.ca-button'];
    selectors.forEach(s => {
      document.querySelectorAll(s).forEach(el => {
        const rect = el.getBoundingClientRect();
        const inViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (inViewport) {
          if (el.tagName === 'IMG') {
            el.loading = 'eager';
            el.fetchpriority = 'high';
          }
          if (el.tagName === 'VIDEO') {
            el.preload = 'auto';
          }
        }
      });
    });
  };

  const applyLazyLoad = () => {
    const elements = document.querySelectorAll('img[data-ca-lazy],video[data-ca-lazy],.ca-slide-title,.ca-slide-subtitle,.ca-button,.ca-text-container,.responsive-image');
    if (isSupported) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            const el = e.target;
            if (el.dataset.src) el.src = el.dataset.src;
            if (el.dataset.srcset) el.srcset = el.dataset.srcset;
            if (el.dataset.sizes) el.sizes = el.dataset.sizes;
            if (el.tagName === 'IMG') {
              el.loading = 'eager';
              el.fetchpriority = 'high';
              el.decoding = 'async';
            }
            if (el.tagName === 'VIDEO') {
              el.preload = 'auto';
            }
            el.classList.add('ca-lazy-loaded', 'loaded');
            obs.unobserve(el);
          }
        });
      }, { rootMargin: config.observerMargin, threshold: config.observerThreshold });
      elements.forEach(el => observer.observe(el));
    } else {
      elements.forEach(el => {
        if (el.dataset.src) el.src = el.dataset.src;
        if (el.dataset.srcset) el.srcset = el.dataset.srcset;
        if (el.dataset.sizes) el.sizes = el.dataset.sizes;
        el.classList.add('ca-lazy-loaded', 'loaded');
      });
    }
  };

  const preloadOnHover = () => {
    document.querySelectorAll('a[href]').forEach(a => {
      const url = a.href;
      a.addEventListener('pointerenter', () => {
        if (url.match(/\.(jpg|jpeg|png|webp|avif|gif)$/)) preloadLink(url, 'image');
        else prefetchLink(url);
      }, { passive: true, once: true });
      a.addEventListener('touchstart', () => {
        if (url.match(/\.(jpg|jpeg|png|webp|avif|gif)$/)) preloadLink(url, 'image');
        else prefetchLink(url);
      }, { passive: true, once: true });
    });
  };

  const preloadNextScrollElements = throttle(() => {
    document.querySelectorAll('img[data-ca-lazy],video[data-ca-lazy]').forEach((el, i) => {
      if (i < 3 && !el.src && !el.srcset) {
        if (el.dataset.src) preloadLink(el.dataset.src, el.tagName === 'VIDEO' ? 'video' : 'image');
        if (el.dataset.srcset) {
          el.dataset.srcset.split(',').forEach(set => preloadLink(set.trim().split(' ')[0]));
        }
      }
    });
  }, 300);

  window.addEventListener('scroll', preloadNextScrollElements, { passive: true });
  window.addEventListener('DOMContentLoaded', () => {
    preloadVisibleElements();
    forceEagerIfInViewport();
    applyLazyLoad();
    preloadOnHover();
    preloadNextScrollElements();
  });

  setInterval(() => { prefetchCount = 0; }, config.prefetchReset);
})();
